const routes = [
  {
    path: "/relatorio/sgm",
    name: "sgm",
    component: () => import("@/views/relatorio/financeiro/ConsolidacaoMensal.vue"),
    meta: {breadcrumb: [{title: "Relatórios"}, {title: " Financeiro"}, {title: "Consolidação Mensal"}]},
  },
  {
    path: "/relatorio/extrato-financeiro",
    name: "finantialExtract",
    component: () => import("@/views/relatorio/financeiro/ExtratoFinanceiro.vue"),
    meta: {breadcrumb: [{title: "Relatórios"}, {title: " Financeiro"}, {title: "Prévia Financeiro Mês"}]},
  },
  {
    path: "/relatorio/comparativo-pagamento",
    name: "finantialCompare",
    component: () => import("@/views/relatorio/financeiro/ComparativoFinanceiro.vue"),
    meta: {breadcrumb: [{title: "Relatórios"}, {title: " Financeiro"}, {title: "Comparativo Pagamento X Baixado"}]},
  },
]

export default routes
